// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"40":"PokemonPage","98":"ErrorPage","268":"GamePage","626":"PokedexPage"}[chunkId] || chunkId) + "." + {"40":"3f2047e1","98":"8975473a","268":"35043665","294":"b1576609","626":"6a3d94c3"}[chunkId] + ".js";
};